import { BaseCustomerUnpublishedInquiryActionsEnum } from '../_enums/base-customer-unpublished-inquiry-actions.enum';

export const BASE_CUSTOMER_UNPUBLISHED_INQUIRY_ACTIONS: string[] = [
  BaseCustomerUnpublishedInquiryActionsEnum.close,
  BaseCustomerUnpublishedInquiryActionsEnum.release,
  BaseCustomerUnpublishedInquiryActionsEnum.edit,
];
